import Accordion from '../../plugins/accordion.js';
const elements = document.querySelectorAll(".js-accordion");
const themes = document.querySelectorAll(".js-accordion-theme");
for (const element of elements) {
  let accordion2 = new Accordion(element, {
    // defaultOpenPanels: [0],
    multipleOpen: true
  });
}
for (const theme of themes) {
  let accordion3 = new Accordion(theme, {
    // defaultOpenPanels: [0],
    multipleOpen: true,
    onOpen: openAction,
    onClose: closeAction
  });
}

function openAction(trigger, panel){
  // trigger.style.color = '#f00'
  trigger.querySelector('.c-button__text').textContent = '閉じる'
}
function closeAction(trigger, panel){
  trigger.querySelector('.c-button__text').textContent = '事例を確認する'
  // trigger.style.color = '#000'
}


// let accordion = new Accordion(".js-accordion2", {
//   defaultOpenPanels: [0],
//   onOpen: hoge,
//   onClose: fuga
// });


// accordion.destroy()
// accordion.init()
